import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PrinterOutlinedSvg from "@ant-design/icons-svg/es/asn/PrinterOutlined";
import AntdIcon from '../components/AntdIcon';
var PrinterOutlined = function PrinterOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: PrinterOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(PrinterOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'PrinterOutlined';
}
export default RefIcon;